import { jsxs as t, jsx as o, Fragment as y } from "react/jsx-runtime";
import { useTranslation as b } from "react-i18next";
import { APIProvider as C, Map as D } from "@vis.gl/react-google-maps";
import h from "../station-feature-list/station-feature-list.js";
import n from "./station.module.less.js";
import { SecondaryButtonLink as p } from "../../../../../components/elements/button/button.js";
import { StationContentSection as N } from "../station-content-section/station-content-section.js";
import { resolveServicesForStation as H, resolveFuelsForStation as R, resolveElectricConnectorsForStation as M, isStationManned as E, getLabelForStationType as P, getTodaysOpeningHoursForStationType as W, getLogoForStation as x, doesStationHaveOpeningHours as O, getOpeningHoursStringFromTimePeriod as u } from "../../../helpers/station-data-resolvers.js";
import { isArrayWithItems as g } from "../../../../../helpers/array-helper.js";
import { getMapLink as k } from "../../../helpers/map-helper.js";
import { MapMarkerWrapper as w } from "../station-markers/map-marker-wrapper/map-marker-wrapper.js";
import { getMarkerTypeForStation as U } from "../../../helpers/marker-helper.js";
import Z from "haversine-distance";
import "react";
import "dayjs";
import "../../../../../contexts/global-context.js";
import "motion/react";
import "@radix-ui/react-dialog";
import { Heading as j } from "../../../../../components/elements/heading/heading.js";
import "@radix-ui/react-accordion";
const V = 13, B = 5, Y = 10, $ = (e, i) => E(e) ? i("FIND_STATION_WELCOME_TO_REFUEL_24_7") : O(e) ? "" : i("FIND_STATION_WELCOME_TO_REFUEL_24_7"), X = (e, i, a) => {
  if (!a)
    return;
  const l = i(e.stationName), d = a.endsWith("/");
  return e.trailerRentalLocationId ? `${a}${d ? "" : "/"}${l}` : a;
}, ue = ({
  station: e,
  geolocation: i,
  showStationMap: a = !1,
  mapApiKey: l,
  trailerRentalPageUrl: d,
  isStationPage: s,
  trackingFunctions: c,
  trailerRentalStationUrlResolveFunction: A
}) => {
  const { t: r } = b(), T = H(e, r), v = R(e, r), L = M(e, r), S = [...v, ...L], I = { lat: e.latitude, lng: e.longitude }, _ = X(
    e,
    A,
    d
  ), f = E(e), m = i ? Z(i, { lat: e.latitude, lng: e.longitude }) : null, F = m ? Math.round(m / 1e3) : null;
  return /* @__PURE__ */ t("div", { className: n.wrapper, children: [
    /* @__PURE__ */ t("div", { className: n.sectionWrapper, children: [
      /* @__PURE__ */ t("div", { className: n.topSection, children: [
        /* @__PURE__ */ t("span", { className: "eyebrow", children: [
          P(e.stationType, r),
          " - ",
          W(e, r)
        ] }),
        /* @__PURE__ */ t("div", { className: n.stationNameWrapper, children: [
          /* @__PURE__ */ o(
            j,
            {
              visualType: "h3",
              semanticType: s ? "h1" : "h3",
              className: ["my-0", n.stationName].join(" "),
              children: e.stationName
            }
          ),
          /* @__PURE__ */ o("div", { className: n.stationIcons, children: x(e.stationType, e.stationConcept) })
        ] }),
        /* @__PURE__ */ t("div", { className: n.adressAndDistance, children: [
          /* @__PURE__ */ t("div", { className: ["mb-0"].join(""), children: [
            e.streetAddress,
            ", ",
            e.city
          ] }),
          m && /* @__PURE__ */ t(y, { children: [
            /* @__PURE__ */ o("div", { children: "•" }),
            /* @__PURE__ */ t("div", { className: "mb-0", children: [
              F,
              " ",
              r("FIND_STATION_KM_ABBREVIATED")
            ] })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ t("div", { className: n.buttonWrapper, children: [
        /* @__PURE__ */ o(
          p,
          {
            label: r("FIND_STATION_DIRECTIONS_CTA"),
            openInNewTab: !0,
            className: n.button,
            url: k(e.streetAddress + ", " + e.postalCode + ", " + e.city),
            onPreNavigate: c.onPreNavigateStationDirections
          }
        ),
        e.phoneNumber && /* @__PURE__ */ o(
          p,
          {
            className: n.button,
            label: e.phoneNumber,
            url: `tel:${e.phoneNumber}`,
            onPreNavigate: c.onPreNavigatePhoneNumber
          }
        ),
        e.trailerRental && e.trailerRentalLocationId && _ && /* @__PURE__ */ o(
          p,
          {
            url: _,
            className: [n.trailerRentalButton, n.button].join(" "),
            isFullWidth: !0,
            label: r("FIND_STATION_TRAILER_RENTAL_CTA"),
            onPreNavigate: c.onPreNavigateTrailerRental
          }
        )
      ] }),
      /* @__PURE__ */ o(
        N,
        {
          title: r(f ? "FIND_STATION_STORE_OPENING_HOURS" : "OPENING_HOURS"),
          text: $(e, r),
          isStationPage: s,
          children: O(e) && /* @__PURE__ */ t("dl", { className: n.openingHours, children: [
            /* @__PURE__ */ t("dt", { children: [
              r("MONDAY").toLowerCase(),
              "–",
              r("FRIDAY").toLowerCase()
            ] }),
            /* @__PURE__ */ o("dd", { children: u(
              e.openingHours.openingHourWeekday,
              e.openingHours.closeHourWeekday,
              r
            ) }),
            /* @__PURE__ */ o("dt", { children: r("SATURDAY").toLowerCase() }),
            /* @__PURE__ */ o("dd", { children: u(
              e.openingHours.openingHourSaturday,
              e.openingHours.closeHourSaturday,
              r
            ) }),
            /* @__PURE__ */ o("dt", { children: r("SUNDAY").toLowerCase() }),
            /* @__PURE__ */ o("dd", { children: u(
              e.openingHours.openingHourSunday,
              e.openingHours.closeHourSunday,
              r
            ) })
          ] })
        }
      ),
      g(T) && /* @__PURE__ */ o(
        N,
        {
          title: r("FIND_STATION_SERVICES_TITLE"),
          text: r("FIND_STATION_SERVICES_TEXT"),
          isStationPage: s,
          children: /* @__PURE__ */ o(h, { items: T })
        }
      ),
      g(S) && /* @__PURE__ */ o(
        N,
        {
          title: r("FIND_STATION_PROPELLANTS_TITLE"),
          text: r("FIND_STATION_PROPELLANTS_TEXT"),
          isStationPage: s,
          children: /* @__PURE__ */ o(h, { items: S })
        }
      )
    ] }),
    a && l && /* @__PURE__ */ o("div", { className: n.mapWrapper, children: /* @__PURE__ */ o(C, { apiKey: l, libraries: ["marker"], children: /* @__PURE__ */ o(
      D,
      {
        id: "station-map-page",
        defaultZoom: Y,
        defaultCenter: I,
        maxZoom: V,
        minZoom: B,
        gestureHandling: "cooperative",
        disableDefaultUI: !0,
        mapTypeId: "roadmap",
        mapId: "3ab6c52371682fb5",
        clickableIcons: !1,
        children: /* @__PURE__ */ o(
          w,
          {
            stationCode: e.stationCode,
            position: I,
            markerType: U(e)
          }
        )
      }
    ) }) })
  ] });
};
export {
  ue as Station,
  ue as default
};
